import { OfferKindEnum } from '../../../../../services/exports/Constants';

const OfferBadge: Partial<Record<OfferKindEnum, string>> = {
  [OfferKindEnum.PercentageOffByMinSpendValue]: '{{percentageAmount}}% de réduction supplémentaire',
  [OfferKindEnum.PercentageOffByProducts]: '{{percentageAmount}}% de réduction supplémentaire',
  [OfferKindEnum.AmountOffByProducts]: '{{amount}} de réduction supplémentaire',
  [OfferKindEnum.Bogo]: '2 POUR 1',
  [OfferKindEnum.BogoHalfPrice]: '1 acheté, 1 à moitié prix !',
  [OfferKindEnum.FreeItemByProducts]: 'Article offert',
  [OfferKindEnum.FreeItemByMinSpendValue]: 'Article offert',
};

export default OfferBadge;
